import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, FirstPersonControls, PointerLockControls } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { TextureLoader } from 'three/src/loaders/TextureLoader.js';
import { MeshBasicMaterial } from 'three';
import { MeshStandardMaterial } from 'three';
import { Vector3 } from 'three';

extend({ EffectComposer, RenderPass, UnrealBloomPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[aspect, 1, 0.5, 0]} />
    </effectComposer>
    </>
  )
}


function Model({ ...props }) {
  const [model, set] = useState();
  const [mixer, set2] = useState();
  const ref = useRef();
  const {camera, mouse} = useThree();
  camera.position.set(0,1,0);
  camera.lookAt(new THREE.Vector3(0, 5, 10));
  useEffect(() => {
    // camera.position.set(new THREE.Vector3(0,1,0));
    void new GLTFLoader().load("./pumpkin.glb", (gltf) => {
      gltf.scene.children[0].children[2].material = new THREE.MeshStandardMaterial({color: 'black'});
      if (gltf.animations.length) {
          set2(new THREE.AnimationMixer(gltf.scene));
      }
      set(gltf);
    });
    
    
  }, [])

  model?.animations.forEach(clip => {
      const action = mixer?.clipAction(clip);
      action?.play();
  });

  useFrame((state, delta) => {

    

    mixer?.update(delta / 2);
    if(model)
    {
      if(clicked) console.log(ref.current);
      let pos = ref.current.position.clone().add(new THREE.Vector3(0,-0.5,0));
      pos.multiplyScalar(-1).normalize().multiplyScalar(0.01);
      ref.current.position.add(pos);
      // ref.current.updateMatrixWorld();
      ref.current.lookAt(new THREE.Vector3(0,1,0));

      let distance = ref.current.position.distanceTo(new THREE.Vector3(0,0.5,0));
      document.getElementById(props.personName).style.opacity = Math.max(5 - distance, 0);

      if(distance < 0.9)
      {
        ref.current.position.set(randPos(props.size), Math.random() * 10, Math.random() * 10 + 5);
        score = 0;
      }
    }
  })

  return model ? 
          <primitive object={model.scene} {...props} ref={ref} scale={[props.size, props.size, props.size]} saveScale={props.size}>
            
            <Html>
              <div id={props.personName} style={{color: 'white', transform: 'translate(-50%, 0)', pointerEvents: 'none', userSelect: 'none'}}>{props.personName}</div>
            </Html>
          </primitive>
          : null
}

function Light() {
  const light = useMemo(() => new THREE.SpotLight(0xffffff, 10, 100, Math.PI / 6), []);
  const gun = useMemo(() => new THREE.Mesh(new THREE.BoxGeometry(0.2, 0.2, 0.8), new THREE.MeshBasicMaterial({color: 'red'})), []);
  const ref = useRef();
  const {scene, camera, mouse} = useThree();
  const raycaster = new THREE.Raycaster();

  useEffect(() => {
    // camera.up=new THREE.Vector3(0,0,1);
    gun.position.set(0,0,0.4);
    ref.current.add(gun);
  })

  useFrame((delta) => {

    raycaster.setFromCamera(mouse, camera);
    
    const intersects = raycaster.intersectObjects([scene.getObjectByName('plane')], false );
    camera.position.set(0,1,0);
    camera.lookAt(new THREE.Vector3(0, mouse.y * 20, 10));
    
    if(intersects.length > 0)
    {
      // ref.current.lookAt(intersects[0].point)
      // light.target.position.copy(intersects[0].point);
      // ref.current.lookAt(intersects[0].point);
      mouse3D = intersects[0].point.normalize();
    }
  })

  return (<>
  <primitive object={light} color={'red'} position={[0, 0.5, 0]}/>
  <primitive object={light.target} position={[100, 0, 200]}  />
  
  <mesh ref={ref}>
    <sphereGeometry args={[0.4,16,16]} />
    <meshBasicMaterial color={'red'} />
  </mesh>
  </>)
}

class Score extends React.Component {
  constructor(props)
  {
    super(props);
    this.state = {
      val: 0
    };
  }
  
  componentDidMount() {
    this.interval = setInterval(() => {this.setState(state => ({val: score}))}, 100);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return(
    <div style={{color: 'white', position: 'absolute', left: '50%', top: '90%', zIndex: 2, transform: 'translate(-50%, 0px)', fontSize: '50px', userSelect: 'none'}}>
      {this.state.val}
    </div>)
  }
}

function Shooting() {
  const ref=useRef();
  const raycaster = new THREE.Raycaster();
  const {scene, camera} = useThree();

  useFrame((delta) => {
    if(clicked) {
      clicked = false;
      ref.current.position.set(0,0.1,0);

      // raycaster.set(new THREE.Vector3(0,0.1,0), mouse3D);
      raycaster.setFromCamera(betterMouse, camera);
      
      const intersects = raycaster.intersectObjects(scene.children, true);
      
      if(intersects.length > 0)
      {
        if(intersects[0].object.name !== 'plane' && intersects[0].object.name !== 'bullet')
        {
          // console.log(intersects[0].object.parent)
          let obj = intersects[0].object.parent.parent;
          console.log(obj.scale);
          if(obj.scale.x > 1) obj.scale.addScalar(-1);
          else {
            obj.scale.set(obj.saveScale, obj.saveScale, obj.saveScale);
            obj.position.set(randPos(obj.saveScale), Math.random() * 10, Math.random() * 10 + 5);
          }
          score++;
        }
      }
    }
    ref.current.position.add(new THREE.Vector3(mouse3D.x, 0, mouse3D.z));
  })

  return (
  <mesh ref={ref} name={'bullet'}>
    <sphereGeometry args={[0.05,10,10]} scale={[1,1,10]}/>
    <meshBasicMaterial color={'red'} />
  </mesh>)
}

const params = new URLSearchParams(window.location.search);
const viewer = params.get('viewer');
let viewerIsOwner = false;
let objkt = parseInt(params.get("objkt"), 10);

const query = `
  query OBJKTBuyers($address: String = "") {
    hic_et_nunc_trade(where: {seller: {address: {_eq: $address}}, token: {creator: {address: {_eq: $address}}}}, distinct_on: buyer_id) {
      buyer {
        address
        name
        purchases_aggregate(where: {seller: {address: {_eq: $address}}}) {
          aggregate {
            count
          }
        }
      }
    }
  }
`;


async function fetchGraphQL(operationsDoc, operationName, variables) {
  const result = await fetch(
    "https://api.hicdex.com/v1/graphql",
    {
      method: "POST",
      body: JSON.stringify({
        query: operationsDoc,
        variables: variables,
        operationName: operationName
      })
    }
  );

  return await result.json();
}

async function doFetch(address) {
  if(!address) return;
  const { errors, data } = await fetchGraphQL(query, "OBJKTBuyers", {"address": address});
  if (errors) {
    console.error(errors);
  }
  else 
  {
    const result = data.hic_et_nunc_trade;
    console.log({ result });
    return result;
  }
}

function checkViewerIsOwner(data) {
  if(!data || !data.token_holders) return;
  if (data.token_holders.some((e) => e.holder.address === viewer)) {
    console.log(`viewer IS owner`);
    viewerIsOwner = true;
  } else {
    console.log(`viewer is NOT owner`);
  }
  //console.log({ OBJKT: data });
}

function changeData(data, id) {
  
  console.log("Refreshing");
  if(!data) return;
  let characters = data.map((holder) => { return [holder.buyer.name ? holder.buyer.name : 
    holder.buyer.address.substr(0,4) + "..." + holder.buyer.address.substr(-4), holder.buyer.purchases_aggregate.aggregate.count]});
  
  return characters;
}

// let data = doFetch();
function randPos(amount)
{
  return (Math.random() * 4 + amount) * (Math.random() > 0.5 ? -1: 1);
}

let betterMouse={}, mouse3D=new THREE.Vector3(0,0,0), score = 0, clicked = false;

function App() {
  const [id, setId] = useState(0);
  const [characters, set] = useState([]);

  useEffect(() => {
    doFetch("tz1PYLW3oyM73xuV62bsFCGbDTv1LsjuDYA2")
      .then((data) => changeData(data, id))
      .then((char) => set(char));
  }, [id])
  console.log(characters)


  return (
    <div id="wrapper" onMouseDown={() => { clicked = true; }}
          onMouseMove = {(e) => { betterMouse = new THREE.Vector2((e.clientX / window.innerWidth) * 2 - 1, (-e.clientY / window.innerHeight) * 2 + 1); }}>
    
    <Score />
  <Canvas>
    <Effect />
      <color attach="background" args={["red"]} />
      {/* <ambientLight intensity = {0.6} /> */}
      {/* <fog attach={'fog'} args={[0xff0000, 5, 100]} /> */}
      <pointLight position={[0,-10,0]} intensity={5} color={0xff0000}/>
      {/* <Light /> */}
      <Suspense fallback={null}>
      {
        characters.map(([name, amount], i) => {return <Model position={[randPos(amount), Math.random() * 10, Math.random() * 10 + 5]} personName={name} size={amount} key={i}/>; })
      }
      </Suspense>
      <mesh rotation={[Math.PI / 2, 0, 0]} name={'plane'}>
        <circleGeometry args={[30, 20,20]} />
        <meshStandardMaterial color={0x660000} side={THREE.DoubleSide}/>
      </mesh>
      <Shooting />

    {/* <OrbitControls /> */}
    {/* <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
